import React, { useEffect, useState } from 'react';
import api from "../api";
import { Button, Modal } from 'react-bootstrap';

/**
 * Helper to format "YYYY-MM-DD" into "MM-DD-YYYY".
 * If you're sure the format is always "YYYY-MM-DD", this is enough.
 */
function formatDate(isoDateString) {
    if (!isoDateString) return '';
    // E.g. "2025-04-14" => [2025, 04, 14]
    const parts = isoDateString.split('-');
    if (parts.length !== 3) return isoDateString; // fallback
    const [year, month, day] = parts;
    return `${month}-${day}-${year}`;
}

const UpcomingRentals = () => {
    const [upcomingBookings, setUpcomingBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [selectedBookingId, setSelectedBookingId] = useState(null);

    const handleCancelClick = (bookingId) => {
        setSelectedBookingId(bookingId);
        setShowCancelModal(true);
    };

    const confirmCancel = async () => {
        try {
            const response = await api.put(`/bookings/cancel/${selectedBookingId}`, null, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            });
            alert(response.data);

            // Remove the canceled booking from state or refetch
            setUpcomingBookings(prev =>
                prev.filter(b => b.id !== selectedBookingId)
            );

        } catch (err) {
            if (err.response && err.response.data) {
                alert(err.response.data);
            } else {
                alert("Failed to cancel booking");
            }
        } finally {
            setShowCancelModal(false);
            setSelectedBookingId(null);
        }
    };

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                const response = await api.get('/bookings/my-upcoming', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
                setUpcomingBookings(response.data);
            } catch (err) {
                setError('Failed to load your upcoming bookings.');
            } finally {
                setLoading(false);
            }
        };
        fetchBookings();
    }, []);

    if (loading) return <p>Loading upcoming rentals...</p>;
    if (error) return <p>{error}</p>;
    if (upcomingBookings.length === 0) {
        return <p>No upcoming rentals found.</p>;
    }

    return (
        <>
            <div>
                <h2>Upcoming Rentals</h2>
                {upcomingBookings.map((booking) => {
                    // Format the start/end dates
                    const pickupDate = formatDate(booking.startDate);
                    const returnDate = formatDate(booking.endDate);

                    // If your Item entity has a separate `description` field, adjust accordingly:
                    const itemNameOrDesc = booking.item?.description || 'N/A';
                    // If it’s truly a "description", use `booking.item?.description`

                    return (
                        <div
                            key={booking.id}
                            className="booking-card"
                            style={{border:'1px solid #ccc', padding:'10px', marginBottom:'10px'}}
                        >
                            <p><strong>Item:</strong> {itemNameOrDesc}</p>
                            <p><strong>Pickup Date:</strong> {pickupDate}</p>
                            <p><strong>Return Date:</strong> {returnDate}</p>
                            {/* Show more booking details if desired */}
                            <p><strong>Days:</strong> {booking.rentalDays || 'N/A'}</p>
                            <p><strong>Total Price:</strong> {booking.totalPrice != null ? `$${booking.totalPrice}` : 'N/A'}</p>
                            <Button variant="danger" onClick={() => handleCancelClick(booking.id)}>
                                Cancel Rental
                            </Button>
                        </div>
                    );
                })}
            </div>

            <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Rental Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        If your rental start date is within the nonrefundable window,
                        you must call the store to cancel. Otherwise, confirm to cancel now.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
                        No, keep rental
                    </Button>
                    <Button variant="danger" onClick={confirmCancel}>
                        Yes, cancel it
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UpcomingRentals;